import { handleNullValues } from 'components/ui/base/table/TableUtils';
import { ReactNode } from 'react';
import { MissingValue } from './styles';

export const MISSING_LABEL = 'Missing';

export const renderMissingValue = (value?: string | number | ReactNode) =>
    value ? handleNullValues(value) : <MissingValue>{MISSING_LABEL}</MissingValue>;

// Required-field messages all read "<Field> is required." (see `getRequiredMessage`) and say
// nothing the generic "Missing" placeholder doesn't - only messages about the *shape* of a value
// the user did enter (format, length, range) are worth showing verbatim in the errors table.
export const isRequiredMessage = (message: string) => /\bis required\b/i.test(message);
